import axios from "axios";

import { getBaseUrl } from "@shared/services/api/config/base-url";

export const setAxiosDefaults = (): void => {
  /*
      On beta and production deployments, dynamically set the baseURL for axios
      depending on whether this Repo is being initialized in a server environment
      or a client environment.
      This allows us to bypass DNS calls as our deployment are on a private network.
    */
  axios.defaults.baseURL = getBaseUrl();

  axios.defaults.withCredentials = true;
  axios.defaults.xsrfCookieName = "csrftoken";
  axios.defaults.xsrfHeaderName = "X-CSRFToken";
};

export const setAxiosCookies = (cookies: string): void => {
  axios.defaults.headers.Cookie = cookies;
};

export const setAxiosCSRFToken = (token: string): void => {
  axios.defaults.headers.common["X-CSRFToken"] = token;
};
